import { css, styled } from 'styled-components';

import { Bar } from '#/modules/salary/components/Bar/Bar';
import { Line } from '#/modules/salary/components/Line/Line';
import { colors, cssBreakpoints, transition } from '#/theme/theme';

export const CareerPathChartContainer = styled.div`
  transition: all ${transition};

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    margin-left: 80px;
  }
`;

export const CareerPathChartWrapper = styled.div`
  margin-top: 40px;
  margin-bottom: 20px;
  position: relative;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    padding-left: 70px;
  }

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    padding-left: 0;
    padding-right: 40px;
  }
`;

export const ChartDataContainer = styled.div<{
  $chartHeight: number;
  $loading: boolean;
}>`
  margin-left: 160px;
  min-height: ${(props) => props.$chartHeight}px;
  pointer-events: ${(props) => (props.$loading ? 'none' : 'initial')};
`;

export const HorizontalAxisContainer = styled.div`
  margin-left: 160px;
`;

export const ChartDataWrapper = styled.div<{
  $xGridInterval: number;
  $yGridInterval: number;
  $showXGridLines?: boolean;
  $showYGridLines?: boolean;
}>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 20px;

  ${(props) =>
    props.$showYGridLines
      ? css`
          background-image:
            linear-gradient(to right, ${colors.white} 5px, transparent 1px),
            linear-gradient(${colors.elementGrey} 1px, transparent 1px);
          background-size: 8px ${props.$yGridInterval}px;
        `
      : undefined}

  ${(props) =>
    props.$showXGridLines
      ? css`
          background-image:
            linear-gradient(to bottom, ${colors.white} 5px, transparent 1px),
            linear-gradient(
              to right,
              ${colors.elementGrey} 1px,
              transparent 1px
            );
          background-size: ${props.$xGridInterval}px 8px;
        `
      : undefined};
`;

export const BarContainer = styled.div<{ $plotHeight: number }>`
  position: relative;
  height: ${(props) => props.$plotHeight}px;
  width: 100%;
`;

export const TooltipContainer = styled.div`
  text-align: center;
`;

export const SigmaLine = styled(Line)`
  path {
    fill-opacity: 0;
    transition: fill-opacity;
    stroke: none;
  }
`;

export const StyledBar = styled(Bar)<{ $duration: number; $stage: string }>`
  &:hover > ${/* sc-selector */ SigmaLine} path {
    fill-opacity: 1;
  }

  transition-duration: ${(props) => props.$duration / 1000}s;
  height: ${(props) => {
    if (props.$stage === 'exit' || props.$stage === 'from') {
      return 0;
    }

    return '100%';
  }};

  path:first-child {
    transition: fill ${(props) => props.$duration / 1000}s ease;
    fill: ${(props) => {
      if (props.$stage === 'exit' || props.$stage === 'from') {
        return colors.brandGreen;
      }

      return colors.skyBlue;
    }};
  }
`;
